import React from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

import './NavBar.css'

function NavBarHome() {
  return (
    <Navbar className='nav py-3' expand="lg" variant="dark">
      <Container>
        <Navbar.Brand href="#"><img className='logoV2' src="https://nilfiskchile.cl/assets/img/menu/logo-v2.svg" alt="Nilfisk" /></Navbar.Brand>
      </Container>
    </Navbar>
  );
}

export default NavBarHome;